/**
 * WMS GRN `Type` codes → i18n keys under `goodsReceipt.typeLabel`.
 * 1 = Standard, 7 = Purchase Order. Unknown codes fall back to the raw value.
 */
const GRN_TYPE_KEYS = {
  1: "standard",
  7: "purchaseOrder",
};

export function grnTypeLabel(rawType, t) {
  if (rawType === null || rawType === undefined || rawType === "") return "";
  const key = GRN_TYPE_KEYS[Number(rawType)];
  return key ? t(`goodsReceipt.typeLabel.${key}`) : String(rawType);
}

/**
 * Reverse of `grnTypeLabel` for list filters: a typed label ("Purchase Order",
 * "standard", …) becomes its numeric code so the API can match `AsnHeader.Type`.
 * Anything that is not a known label is returned unchanged.
 */
export function grnTypeCodeFromLabel(value, t) {
  const needle = String(value ?? "").trim().toLowerCase();
  if (!needle) return value;
  for (const [code, key] of Object.entries(GRN_TYPE_KEYS)) {
    const label = String(t(`goodsReceipt.typeLabel.${key}`) ?? "").trim().toLowerCase();
    if (label && (label === needle || key.toLowerCase() === needle)) return Number(code);
  }
  return value;
}
